var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"values-histogram"},[_c('svg',{ref:"svg",attrs:{"width":_vm.size.width,"height":_vm.size.height}})])}
var staticRenderFns = []

export { render, staticRenderFns }